import { render, staticRenderFns } from "./SubNavbar.vue?vue&type=template&id=616470ac&scoped=true&"
import script from "./SubNavbar.vue?vue&type=script&lang=js&"
export * from "./SubNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616470ac",
  null
  
)

export default component.exports